import { useAPI } from "~/uses/useMyFetch";
import { useProductFilterStore } from "~/store/productFilter.store";
import { productFilterConfig } from "~/config/productFilter.config";

export const useCriteriaStore = defineStore("criteriaStore", {
  state: () => {
    return {
      criteria: null,
    };
  },
  actions: {
    async fetch() {
      await useAPI("/catalog/product/criteria", {
        params: this.buildRequestParams(),
        lazy: true,
      }).then((data) => {
        this.criteria = data;
      });
    },
    buildRequestParams() {
      const params = Object.entries(useProductFilterStore().params).filter(
        ([k, _]) => !["page", "limit"].includes(k),
      );
      const requestParams = {};

      for (const [paramKey, paramValue] of params) {
        requestParams[
          productFilterConfig[paramKey].request?.alias ?? paramKey
        ] =
          productFilterConfig[paramKey].request?.encode(paramValue) ??
          productFilterConfig[paramKey].state.encode(paramValue);
      }

      return requestParams;
    },
  },
  getters: {
    getCriteria: (state) => state.criteria,
    getPriceRange: (state) => state.criteria.priceRange,
    getSpecification: (state) => {
      return (slug) => {
        return state.criteria.specifications.find(
          (specification) => specification.slug === slug,
        );
      };
    },
    getSpecificationOption: (state) => {
      return (slug, optionSlug) => {
        return state
          .getSpecification(slug)
          ?.options.find((option) => option.slug === optionSlug);
      };
    },
  },
});
